import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';
import './index.scss';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Shed Labs s.r.o. - Experienced Software Engineers"
      meta={[
        {
          name: 'description',
          content:
            'We are a team of social and experienced software engineers in Prague. We work with you as a cross-functional team to craft software with amazing tech, customer experience and pragmatism.',
        },
        {
          name: 'keywords',
          content:
            'web development, mobile development, apps, design, ux, consulting, tech, experience, experienced, team',
        },
      ]}
    />
    <Header />
    <div className="page">{children()}</div>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js